var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2436_1732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1458 3.6665L12.2483 6.83317H7.22917C5.4875 6.83317 4.0625 8.25817 4.0625 9.99984V28.9998C4.0625 30.7415 5.4875 32.1665 7.22917 32.1665H32.5625C34.3042 32.1665 35.7292 30.7415 35.7292 28.9998V9.99984C35.7292 8.25817 34.3042 6.83317 32.5625 6.83317H27.5433L24.6458 3.6665H15.1458Z",
    stroke: "#222222",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0938 26.625C24.3567 26.625 27.8125 23.1692 27.8125 18.9062C27.8125 14.6433 24.3567 11.1875 20.0938 11.1875C15.8308 11.1875 12.375 14.6433 12.375 18.9062C12.375 23.1692 15.8308 26.625 20.0938 26.625Z",
    stroke: "#222222",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2436_1732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/cameraIcon.dc211ee19c4962d279cf34088479110c.svg";
export { ForwardRef as ReactComponent };